<template>
  <div>
    <add-card :user="user" v-if="!user.stripe_id || user.stripe_id.startsWith('comped')" @success="activate"></add-card>
    <div class="text-right">
      <button class="button mt-2 bg-green hover:bg-green-dark text-green-lightest hover:text-white" v-show="next" @click="activate">Add Location</button>
    </div>
  </div>
</template>

<script>
export default {
  props: ['user', 'comped', 'location'],
  data() {
    return {
      next: !this.user.stripe_id || this.user.stripe_id.startsWith('comped') ? false : true
    }
  },
  methods: {
    activate() {
      axios.post('/api/v1/locations/' + this.location + '/activated')
        .then(({data}) => {
          if (data == 'success') {
            window.location.href = '/admin/locations/' + this.location + '/edit'
          }
        })
    }
  }
}
</script>
